import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '福利分类',
    links: [
      { label: '限时优惠券', to: '/category/limited-coupons' },
      { label: '免费资源', to: '/category/free-resources' },
      { label: '会员福利', to: '/category/member-benefits' },
      { label: '积分兑换', to: '/category/points-exchange' },
      { label: '折扣好物', to: '/category/discount-goods' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about' },
      { label: '用户口碑', to: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', to: '/#faq' },
      { label: '使用指南', to: '/article/taobao-618-coupon-guide' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="no-underline">
              <span
                className="text-2xl font-bold text-background-50"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                福利吧
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              每日精选福利汇聚，省钱好物一站搞定。
              <br />
              专注于精选优惠、折扣、免费资源与会员权益的福利聚合平台。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 福利吧 fuliba.com All Rights Reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-sm no-underline" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-sm no-underline" rel="nofollow">用户协议</a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-sm no-underline" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}